import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {AuthenticationService} from '@services/authentification.service';
import {HttpClient} from '@angular/common/http';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {MatDialog} from '@angular/material/dialog';
import {EditCaracComponent} from '@components/popup/edit-carac/edit-carac.component';
import {EditAnnexeComponent} from '@components/popup/edit-annexe/edit-annexe.component';
import {EditOtherCaracComponent} from '@components/popup/edit-other-carac/edit-other-carac.component';
import {EditDiagComponent} from '@components/popup/edit-diag/edit-diag.component';

@Component({
    selector: 'app-widget-descriptif',
    templateUrl: './descriptif.component.html',
    styleUrls: ['./descriptif.component.scss']
})
export class DescriptifComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();

    constructor(
        public dialog: MatDialog,
        private http: HttpClient,
        public cityService: CityService,
        public adService: AdService,
        public authenticationService: AuthenticationService) {
    }

    ngOnInit() {
        this.favorite.ad.description = this.favorite.ad.description.replace(/\\r\\n\\r/gm, '<br/>').replace(/\\n/gm, '<br/>').replace(/\\r/gm, '');
    }

    editCarac() {
        const dialogRef = this.dialog.open(EditCaracComponent, {
            width: '600px',
            data: {favorite: this.favorite},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.favorite.has_copro = result.has_copro;
                this.favorite.lot_copro = result.lot_copro;
                this.favorite.floor = result.floor;
                this.favorite.floor_building = result.floor_building;
                this.favorite.year_building = result.year_building;
                this.favorite.orientation = result.orientation;
                this.favorite.heating = result.heating;
                this.favorite = this.adService.updateValues(result);
                this.favoriteChange.emit();
            }
        });
    }

    editAnnexe() {
        const dialogRef = this.dialog.open(EditAnnexeComponent, {
            width: '600px',
            data: {favorite: this.favorite},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.favorite.bedrooms = result.bedrooms;
                this.favorite.restrooms = result.restrooms;
                this.favorite.bathrooms = result.bathrooms;
                this.favorite.shower_rooms = result.shower_rooms;
                this.favorite.parking = result.parking;
                this.favorite.pool = result.pool;
                this.favorite.cellar = result.cellar;
                this.favorite.outside = result.outside;
                this.favorite = this.adService.updateValues(this.favorite);
                this.favoriteChange.emit();
            }
        });
    }

    editOther() {
        const dialogRef = this.dialog.open(EditOtherCaracComponent, {
            width: '600px',
            data: {favorite: this.favorite},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.favorite.elevator = result.elevator;
                this.favorite.urgent = result.urgent;
                this.favorite.rent = result.rent;
                this.favorite.work = result.work;
                this.favorite.renov = result.renov;
                this.favorite.owner_type = result.owner_type;
                this.favorite.disabled_access = result.disabled_access;
                this.favorite.guardian = result.guardian;
                this.favorite.intercom = result.intercom;
                this.favorite.closed_view = result.closed_view;
                this.favorite.digital_code = result.digital_code;
                this.favorite = this.adService.updateValues(this.favorite);
                this.favoriteChange.emit();
            }
        });
    }

    editDiag() {
        const dialogRef = this.dialog.open(EditDiagComponent, {
            width: '600px',
            data: {favorite: this.favorite},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.favorite.energy_rate = result.energy_rate;
                this.favorite.energy_rate_value = result.energy_rate_value;
                this.favorite.ges = result.ges;
                this.favorite.ges_value = result.ges_value;
                this.favorite = this.adService.updateValues(this.favorite);
                this.favoriteChange.emit();
            }
        });
    }
}
